import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
var i = {
	16: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M4.5 1H9.79297L13.5 4.70703V14C13.5 14.4229 13.3946 14.6483 13.2715 14.7715C13.1483 14.8946 12.9229 15 12.5 15H4.5C4.07707 15 3.85168 14.8946 3.72852 14.7715C3.60536 14.6483 3.5 14.4229 3.5 14V2C3.5 1.57707 3.60536 1.35168 3.72852 1.22852C3.85168 1.10536 4.07707 1 4.5 1Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10 0.5V3.7C10 4.23333 10.2667 4.5 10.8 4.5H14L10 0.5Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 1,
					y: 8,
					width: 13.5,
					height: 6,
					rx: 1,
					fill: "#B63966"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.18324 9.22729L3.84322 10.3427H3.86879L4.53196 9.22729H5.31339L4.31463 10.8637L5.33576 12.5H4.53995L3.86879 11.383H3.84322L3.17205 12.5H2.37944L3.40377 10.8637L2.39862 9.22729H3.18324Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.84124 9.22729H6.69458L7.59586 11.4262H7.63421L8.53549 9.22729H9.38883V12.5H8.71766V10.3699H8.6905L7.84355 12.484H7.38652L6.53958 10.3619H6.51241V12.5H5.84124V9.22729Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.0489 12.5V9.22729H10.7409V11.9295H12.1439V12.5H10.0489Z",
					fill: "white"
				})
			]
		}),
		width: 16,
		height: 16
	},
	24: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 24 24",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M6 1.5H14.793L19.5 6.20703V21C19.5 21.5896 19.353 21.94 19.1465 22.1465C18.94 22.353 18.5896 22.5 18 22.5H6C5.41041 22.5 5.06001 22.353 4.85352 22.1465C4.64702 21.94 4.5 21.5896 4.5 21V3C4.5 2.41041 4.64702 2.06001 4.85352 1.85352C5.06001 1.64702 5.41041 1.5 6 1.5Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15 1V5C15 5.66667 15.3333 6 16 6H20L15 1Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 1,
					y: 12,
					width: 18,
					height: 8,
					rx: 1.5,
					fill: "#B63966"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.24432 14.1364L5.12429 15.6236H5.15838L6.04261 14.1364H7.08452L5.75284 16.3182L7.11435 18.5H6.05327L5.15838 17.0106H5.12429L4.2294 18.5H3.17258L4.53835 16.3182L3.19815 14.1364H4.24432Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.78832 14.1364H8.92611L10.1278 17.0682H10.1789L11.3807 14.1364H12.5184V18.5H11.6236V15.6598H11.5873L10.4581 18.4787H9.84869L8.71943 15.6491H8.68321V18.5H7.78832V14.1364Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.3986 18.5V14.1364H14.3211V17.7393H16.1919V18.5H13.3986Z",
					fill: "white"
				})
			]
		}),
		width: 24,
		height: 24
	},
	40: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 40 40",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M10 2.5H24.793L32.5 10.207V35C32.5 35.9229 32.2696 36.5233 31.8965 36.8965C31.5233 37.2696 30.9229 37.5 30 37.5H10C9.07707 37.5 8.47668 37.2696 8.10352 36.8965C7.73036 36.5233 7.5 35.9229 7.5 35V5C7.5 4.07707 7.73036 3.47668 8.10352 3.10352C8.47668 2.73036 9.07707 2.5 10 2.5Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M25 2V9C25 9.66667 25.3333 10 26 10H33L25 2Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 3,
					y: 21,
					width: 27,
					height: 13,
					rx: 2,
					fill: "#B63966"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.86648 24.4545L9.18644 26.6854H9.23757L10.5639 24.4545H12.1268L10.1293 27.7273L12.1715 31H10.5799L9.23757 28.766H9.18644L7.84411 31H6.25888L8.30753 27.7273L6.29723 24.4545H7.86648Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.1825 24.4545H14.8892L16.6917 28.8523H16.7684L18.571 24.4545H20.2777V31H18.9353V26.7397H18.881L17.1871 30.968H16.273L14.5792 26.7237H14.5248V31H13.1825V24.4545Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M21.5978 31V24.4545H22.9817V29.859H25.7878V31H21.5978Z",
					fill: "white"
				})
			]
		}),
		width: 40,
		height: 40
	}
}, a = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: i[t],
	...r
});
//#endregion
export { a as FileXmlIcon };
